const KEYBOARD_KEYS = {
  ENTER: 'Enter',
};

export default KEYBOARD_KEYS;
